/**
* @file 财务管理
* */
<template>
  <div id="financeTabs">
    <tab-frame v-if="tabs.length > 0" :tabs="tabs"></tab-frame>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "financeTabs",
  data() {
    return {
      // tabs列表
      tabs: [],
      tabAction: null,
    };
  },
  computed: {
    ...mapGetters({ 'permissionsGetter': 'permissionsGetter' })
  },
  watch: {
    tabAction(val) {
      this.$router.push(val);
    },
    $route: {
      handler(val) {
        this.tabAction = val.path;
        if (val.path == '/financial' && this.tabs.length > 0) {
          this.$nextTick(() => {
            this.tabAction = this.tabs[0].name;
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    let tabs = [];
    setTimeout(() => {
      if (this.menuPreFn(68)) tabs.push({ label: "专线订单", name: "/financialCustomize", icon: 'el-icon-document' });
      if (this.menuPreFn(69)) tabs.push({ label: "班线订单", name: "/financialLine", icon: 'el-icon-tickets' });
      if (this.menuPreFn(70)) tabs.push({ label: "旅游包车", name: "/financialChartered", icon: 'el-icon-truck' });
      if (this.menuPreFn(71)) tabs.push({ label: "专线包车", name: "/financialCustomizeChartered", icon: 'el-icon-truck' });
      if (this.menuPreFn(90)) tabs.push({ label: "顺风车订单", name: "/financeFlowingHitchRide", icon: 'el-icon-position' });
      if (this.menuPreFn(113)) tabs.push({ label: "场站订单", name: "/czOrderFlowing", icon: 'el-icon-office-building' });
      if (this.menuPreFn(129)) tabs.push({ label: "文旅行程", name: "/financialLvYou", icon: 'el-icon-map-location' });
      this.tabs = tabs;
      this.tabAction = this.tabAction && this.tabAction != '/financial' ? this.tabAction : tabs[0].name;
    }, this.permissionsGetter.length > 0 ? 0 : 1500)
  },
};
</script>

<style lang="less">
#financeTabs {
  height: 100%;
}
</style>
